module.exports = __webpack_public_path__ + "static/media/CloseXWhite.210d1b0d.svg";